import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem, TreeNode } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatabaseValueFound } from 'src/modules/enaio/shared/DatabaseValueFound';
import { DbConnectionConfig } from 'src/modules/enaio/shared/DbConnectionConfig';
import { EnaioAccessType } from 'src/modules/enaio/shared/EnaioAccessType';
import { EnaioCabinet } from 'src/modules/enaio/shared/EnaioCabinet';
import { EnaioCallGetClientEvents } from 'src/modules/enaio/shared/EnaioCallGetClientEvents';
import { EnaioCallGetDuplicateDatasets } from 'src/modules/enaio/shared/EnaioCallGetDuplicateDatasets';
import { EnaioCallGetObjectCounts } from 'src/modules/enaio/shared/EnaioCallGetObjectCounts';
import { EnaioCallGetObjectDef } from 'src/modules/enaio/shared/EnaioCallGetObjectDef';
import { EnaioCallGetUserGroupList } from 'src/modules/enaio/shared/EnaioCallGetUserGroupList';
import { EnaioCallGetUserPermissions } from 'src/modules/enaio/shared/EnaioCallGetUserPermissions';
import { EnaioCallSelect } from 'src/modules/enaio/shared/EnaioCallSelect';
import { EnaioCallUpdateClientEvent } from 'src/modules/enaio/shared/EnaioCallUpdateClientEvent';
import { EnaioCheckPermissionResult } from 'src/modules/enaio/shared/EnaioCheckPermissionResult';
import { EnaioClientEvent } from 'src/modules/enaio/shared/EnaioClientEvent';
import { EnaioCondition } from 'src/modules/enaio/shared/EnaioCondition';
import { EnaioDbDataType } from 'src/modules/enaio/shared/EnaioDbDataType';
import { EnaioDuplicateDataset } from 'src/modules/enaio/shared/EnaioDuplicateDataset';
import { EnaioExportOptions } from 'src/modules/enaio/shared/EnaioExportOptions';
import { EnaioGuiControlType } from 'src/modules/enaio/shared/EnaioGuiControlType';
import { EnaioGuiField } from 'src/modules/enaio/shared/EnaioGuiField';
import { EnaioImportOptions } from 'src/modules/enaio/shared/EnaioImportOptions';
import { EnaioMainType } from 'src/modules/enaio/shared/EnaioMainType';
import { EnaioObjectDef } from 'src/modules/enaio/shared/EnaioObjectDef';
import { EnaioObjectDefChange } from 'src/modules/enaio/shared/EnaioObjectDefChange';
import { EnaioObjectId } from 'src/modules/enaio/shared/EnaioObjectId';
import { EnaioObjectType } from 'src/modules/enaio/shared/EnaioObjectType';
import { EnaioObjectTypeId } from 'src/modules/enaio/shared/EnaioObjectTypeId';
import { EnaioUserGroup } from 'src/modules/enaio/shared/EnaioUserGroup';
import { GenericDataType } from 'src/modules/enaio/shared/GenericDataType';
import { PlotDefinition } from 'src/modules/enaio/shared/PlotDefinition';
import { PlotResult } from 'src/modules/enaio/shared/PlotResult';
import { PlotDefinitionComponent } from 'src/modules/sm-base/components/plot-definition/plot-definition.component';
import { PlotComponent } from 'src/modules/sm-base/components/plot/plot.component';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldListItem } from 'src/modules/sm-base/models/frontend-field-list-item.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { GenericFieldDefinition } from 'src/modules/sm-base/models/generic-field-definition.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { ArrayOrSingle } from 'src/modules/sm-base/shared/array-or-single.model';
import { Progressor } from 'src/modules/utils/misc/Progressor';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { TreeNode2 } from 'src/modules/utils/misc/tree-node2.model';
import { Wrapper } from 'src/modules/utils/misc/wrapper.model';
import { Map2 } from 'src/modules/utils/shared/map2.model';
import { OrdinaryObject, OrdinaryObjectNumber } from 'src/modules/utils/shared/ordinary-object.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { FrontendScriptDefinition } from '../../models/frontend-script-definition.model';
import { FrontendScriptsDefinition } from '../../models/frontend-scripts-definition.model';
import { EnaioObjectTypeStatistics } from 'src/modules/enaio/shared/EnaioObjectTypeStatistics';
import { EnaioCallGetObjectTypeStatistics } from 'src/modules/enaio/shared/EnaioCallGetObjectTypeStatistics';
import { DbIndex } from 'src/modules/enaio/shared/DbIndex';
import { EnaioCallGetDbIndexes } from 'src/modules/enaio/shared/EnaioCallGetDbIndexes';
import { FrontendScriptEditorComponent } from '../frontend-script-editor/frontend-script-editor.component';
import { FrontendEnaioMapper } from 'src/modules/enaio/models/frontend-enaio-mapper.model';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';
import { TreeIcon } from 'src/modules/sm-base/models/tree-icon.model';

@Component({
    selector: 'app-enaio-object-def',
    templateUrl: './enaio-object-def.component.html',
    styleUrls: ['./enaio-object-def.component.scss']
})
export class EnaioObjectDefComponent extends ComponentView {

    _Utils = Utils;

    loading = true;
    def: EnaioObjectDef;
    indexes: DbIndex[] = [];
    tree: TreeNode2[];
    events: EnaioClientEvent[];
    userRightsTable: TableData;
    fieldsTable: TableData;
    allFieldsTable: TableData;
    relationsFromTable: TableData;
    relationsToTable: TableData;
    fieldsSelectTable: TableData;
    duplicateDatasetsTable: TableData;
    userGroups: EnaioUserGroup[];
    selOldCode: string;
    duplicateDatasets: EnaioDuplicateDataset[];
    objectCounts: OrdinaryObject<number> = {};
    tabIndex = 0;
    findDupsTabIndex = 0;
    noDupIds = false;
    maxDups = 1000;
    dupType = 2;
    minCount = 2;
    findValueForm: FrontendFormDefinition;
    findValueTable: TableData;
    historyForm: FrontendFormDefinition;
    historyTable: TableData;
    statisticsForm: FrontendFormDefinition;
    statisticsTable: TableData;
    progressor = new Wrapper<Progressor>();
    clientForm: FrontendFormDefinition;

    dhGeneratorItems: MenuItem[] = [];
    openDupsMenu: MenuItem[] = [];
    selectedObjectTypeNode: ArrayOrSingle<TreeNode>;
    selectedObjectType: EnaioObjectType;

    scripts = new FrontendScriptsDefinition();

    hasEvents: OrdinaryObjectNumber<boolean> = {};

    importOptions: EnaioImportOptions;
    exportOptions: EnaioExportOptions;

    @ViewChild("plot")
    plot: PlotComponent;
    @ViewChild("plotDefComponent")
    plotDefComponent: PlotDefinitionComponent;
    plotData: PlotResult;
    plotFields: GenericFieldDefinition[] = [];
    plotTemplates: PlotDefinition[];
    plotDefinition: PlotDefinition;

    @ViewChild("clientEventsScriptEditor")
    clientEventsScriptEditor: FrontendScriptEditorComponent;


    async initParams(): Promise<boolean> {
        await this.refresh();
        this.dhGeneratorItems = [
            {
                label: "Feldliste",
                command: this.generateDhFieldList.bind(this)
            },
            {
                label: "ImportSource",
                command: this.generateDhImportSource.bind(this)
            },
            {
                label: "FromEnaioWorker",
                command: this.generateDhFromEnaioWorker.bind(this)
            },
            {
                label: "ToEnaioWorker",
                command: this.generateDhToEnaioWorker.bind(this)
            }
        ];
        this.openDupsMenu = [
            {
                label: "Außer Älteste",
                command: async () => this.openDupsInEnaio(true)
            },
            {
                label: "Außer Neueste",
                command: async () => this.openDupsInEnaio(false)
            }
        ];
        this.findValueForm = new FrontendFormDefinition([
            new FrontendFieldDefinition("query", "Suche nach", FrontendFieldType.text, { mandatory: true }),
            new FrontendFieldDefinition("like", "LIKE Operator", FrontendFieldType.checkBox),
            new FrontendFieldDefinition("searchArea", "Suchbereich", FrontendFieldType.comboBox, { mandatory: true, dropdownEditable: false, listItems: ["Dieser Objekttyp", "Dieser Schrank", "Alle Schränke"].map(s => new FrontendFieldListItem(s, s))})
        ]);

        this.historyForm = new FrontendFormDefinition([
            new FrontendFieldDefinition("searchArea", "Suchbereich", FrontendFieldType.comboBox, { value: "Alle Schränke", mandatory: true, dropdownEditable: false,
                listItems: ["Dieser Objekttyp", "Dieser Schrank", "Alle Schränke"].map(s => new FrontendFieldListItem(s, s))}),
            new FrontendFieldDefinition("compareToFileName", "Vergleiche mit Definition aus Datei", FrontendFieldType.text)
        ]);

        this.statisticsForm = new FrontendFormDefinition([
            new FrontendFieldDefinition("searchArea", "Suchbereich", FrontendFieldType.comboBox, { value: "Alle Schränke", mandatory: true, dropdownEditable: false,
                listItems: ["Dieser Objekttyp", "Dieser Schrank", "Alle Schränke"].map(s => new FrontendFieldListItem(s, s))}),
            new FrontendFieldDefinition("followForeignIds", "Verweisen folgen", FrontendFieldType.checkBox),
            new FrontendFieldDefinition("countDuplicateForeignIds", "Mehrfach vorkommende Verweisdokumente mehrfach zählen", FrontendFieldType.checkBox),
            new FrontendFieldDefinition("byMimeType", "Zusätzlich nach mimetype gruppieren", FrontendFieldType.checkBox),
            new FrontendFieldDefinition("countMultipleDocumentsOfIdAsOne", "Mehrere Dokumente eines Objekts als ein Dokument zählen", FrontendFieldType.checkBox),
            new FrontendFieldDefinition("conditions", "Bedingungen", FrontendFieldType.table, {
                value: [], 
                tableColumns: [
                    new TableColumn("field", "Feld (interner Name)", TableCellType.text, { 
                        editable: true, 
                        autoWidth: 10, 
                        valueGetter: value => (value as EnaioObjectId).internalName,
                        valueSetter: event => (event.row.values[event.column.colId] as EnaioObjectId).internalName = event.value
                    }),
                    new TableColumn("value", "Wert", TableCellType.text, { editable: true, autoWidth: 10 }),
                    new TableColumn("comparison", "Operator", TableCellType.text, { 
                        editable: true, 
                        autoWidth: 2,  
                        editor: new FrontendFieldDefinition("field", "Feld", FrontendFieldType.comboBox, { 
                            dropdownEditable: true,
                            listItems: ["=", "!=", "<", "<=", ">", ">=", "LIKE"].map(op => new FrontendFieldListItem(op, op)),
                        })
                    })
                ], 
                generateEmptyTableItem: (): any => new EnaioCondition(EnaioObjectId.byInternalName(""), "", "=")
            })
        ]);

        this.loading = false;
        return true;
    }

    async refresh(): Promise<void> {
        this.def = await DhTools.enaioCall<EnaioObjectDef>(new EnaioCallGetObjectDef());
        this.userGroups = await DhTools.enaioCall(Utils.fromPlain(EnaioCallGetUserGroupList, {}));
        this.events = await DhTools.enaioCall<EnaioClientEvent[]>(new EnaioCallGetClientEvents());
        this.indexes = await DhTools.enaioCall<DbIndex[]>(new EnaioCallGetDbIndexes());

        for (let cab of this.def.cabinets) {
            for (let ot of cab.objectTypes) {
                ot.parent = cab;
                this.hasEvents[ot.Id] = this.events.some(e => e.objectTypeId == ot.Id);
            }
        }

        this.tree = GuiUtils.generateTree(Utils.arrayExplode(this.def.cabinets, c => c.objectTypes.map(ot => [ot, c])), tuple => [tuple[1].name, tuple[0]],
            (_, keys, index) => ({ 
                key: keys[index], 
                data: keys[index], 
                additional: { fieldNames: keys[index] instanceof EnaioObjectType ? Utils.arrayItemsToString((keys[index] as EnaioObjectType).getAllFields(), ";", f => f.name + ";" + f.internalName + ";" + f.dbFieldName) : "" }, 
                label: Utils.isString(keys[index]) ? keys[index] : keys[index] instanceof EnaioCabinet ? keys[index].name : keys[index] instanceof EnaioObjectType ? keys[index].name : "<???>", 
                sortText: keys[index] instanceof EnaioObjectType ? (keys[index] as EnaioObjectType).mainType == EnaioMainType.folder ? "1" : (keys[index] as EnaioObjectType).mainType == EnaioMainType.register ? "2" : "3" : "3" 
            }), true);

        for (let node of GuiUtils.flattenTree(this.tree)) {
            node.icons = Utils.arrayWithoutNull([
                this.hasEvents[node.data?.Id] ? new TreeIcon("hasEvent", "fas fa-code") : null, 
                node.data instanceof EnaioObjectType && node.data.mainType == EnaioMainType.folder ? new TreeIcon("isFolder", "fas fa-folder") : null,
                node.data instanceof EnaioObjectType && node.data.mainType == EnaioMainType.register ? new TreeIcon("isRegister", "fas fa-folder-tree") : null
            ]);
        }

        if (this.tree.length > 0) {
            this.tree[0].expanded = true;
        }
    }

    getSelectedObjectType(): EnaioObjectType {
        let sel = Utils.asSingle(this.selectedObjectTypeNode);
        if (sel == null) {
            return null;
        }
        if (sel.data instanceof EnaioObjectType) {
            return sel.data;
        }
        else if (Utils.isString(sel.data)) {
            return sel.children.find(child => child.label == sel.label)?.data as EnaioObjectType;
        }
        else {
            return null;
        }
    }

    fillAllFields(): void {
        this.allFieldsTable = this.getFieldsTable(null);
    }

    getFieldsTable(sel: EnaioObjectType): TableData {
        let rows: TableRow[] = [];
        for (let ot of sel != null ? [sel] : this.def.getAllObjectTypes()) {
            rows = [...rows, ...Utils.arrayMapWithIndex(ot.getAllFields(), (f, index) => new TableRow(ot.parent.name + "|" + ot.name + "|" + index, f, ({
                _tools: [
                    new TableCellButton("findUnique", "fas fa-fingerprint", "Eindeutige finden"),
                    new TableCellButton("jumpToEvent", "fas fa-code", "Zu Event springen", this.events.some(event => event.parameters == f.osGuid)),
                    new TableCellButton("showDropdownEntries", "fas fa-square-caret-down", "Dropdown-Einträge anzeigen", f.controlType2 == EnaioGuiControlType.comboBox)
                ],
                archive: ot.parent.name,
                objectType: ot.name,
                index,
                tabOrder: f.tabOrder,
                name: f.name,
                internalName: f.internalName,
                dbFieldName: f.dbFieldName,
                maxLength: f.maxLength,
                controlType: EnaioGuiControlType.getName(f.controlType2),
                dataType: EnaioDbDataType.getName(f.dataType),
                hidden: !f.isControlVisible && !f.isLabelVisible,
                indexes: Utils.arrayItemsToString(this.indexes.filter(index => Utils.stringEqualsCi(index.tableName, ot.tableName) && index.columns.some(col => Utils.stringEqualsCi(col, f.dbFieldName))), ", ", idx => idx.name),
                additional: Utils.arrayItemsToString(Utils.arrayWithoutNull([
                    !Utils.isNoe(f.searchGroupName) ? "Suchgruppe: " + f.searchGroupName : null,
                    f.controlType2 == EnaioGuiControlType.radioButton ? "Radio-Value: " + f.radioButtonValue : null]))
            }) as OrdinaryObject))];
        }

        return new TableData([
            new TableColumn("_tools", "", TableCellType.button, { autoWidth: 2 }),
            sel == null ? new TableColumn("archive", "Archiv", TableCellType.text, { autoWidth: 10 }) : null,
            sel == null ? new TableColumn("objectType", "Objekttyp", TableCellType.text, { autoWidth: 10 }) : null,
            new TableColumn("index", "Index", TableCellType.int, { autoWidth: 3 }),
            new TableColumn("tabOrder", "Tab Order", TableCellType.int, { autoWidth: 3 }),
            new TableColumn("name", "Name", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("internalName", "Interner Name", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("dbFieldName", "Datenbankname", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("maxLength", "Länge", TableCellType.int, { autoWidth: 5 }),
            new TableColumn("controlType", "GUI-Typ", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("dataType", "Datentyp", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("hidden", "Versteckt", TableCellType.yesNo, { autoWidth: 1 }),
            new TableColumn("indexes", "Indizes", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("additional", "Erweitert", TableCellType.text, { autoWidth: 20 })
        ], rows, sel == null ? [new TableSortColumn("archive"), new TableSortColumn("objectType"), new TableSortColumn("name")] : [new TableSortColumn("name")]);
    }

    async selectedObjectTypeChanged(_: any): Promise<void> {
        this.selectedObjectType = this.getSelectedObjectType();
        
        let events = this.events.filter(e => e.objectTypeId == -1 || e.objectTypeId == this.selectedObjectType.Id);
        this.scripts = DhTools.objectTypeToScriptDefinition(events);

        this.userRightsTable = null;

        this.fieldsTable = this.getFieldsTable(this.selectedObjectType);

        let dbFields = this.selectedObjectType.getAllFields().filter(f => !Utils.isNoe(f.dbFieldName));
        this.fieldsSelectTable = this.selectedObjectType == null ? null : new TableData([
            new TableColumn("key", "Schlüssel", TableCellType.yesNo, { autoWidth: 1, editable: true }),
            new TableColumn("index", "Index", TableCellType.int, { autoWidth: 4 }),
            new TableColumn("name", "Name", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("internalName", "Interner Name", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("dbFieldName", "Datenbankname", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("condition", "Bedingung", TableCellType.text, { autoWidth: 20, editable: true })
        ], Utils.arrayMapWithIndex(dbFields, (f, index) => new TableRow(Utils.toString(index), f, ({
            key: dbFields.length <= 3,
            index,
            name: f.name,
            internalName: f.internalName,
            dbFieldName: f.dbFieldName,
            condition: ""
        }) as OrdinaryObject)), [new TableSortColumn("index")]);

        this.relationsFromTable = this.selectedObjectType == null ? null : new TableData([
            new TableColumn("objectType", "Darf enthalten", TableCellType.text, { flex: 1 }),
            new TableColumn("max", "Anzahl", TableCellType.int, { autoWidth: 3 })
        ], this.selectedObjectType.mainType != EnaioMainType.folder && this.selectedObjectType.mainType != EnaioMainType.register ? [] : this.selectedObjectType.parent.objectTypes.filter(ot => ot.mainType != EnaioMainType.folder && Utils.arrayFindAndConvert(this.selectedObjectType.objectLimits, ol => ol.typeId == ot.Id, ol => ol.max, 1) != 0).map(ot => new TableRow("", ot, {
            objectType: ot.name,
            max: Utils.arrayFindAndConvert(this.selectedObjectType.objectLimits, ol => ol.typeId == ot.Id, ol => Utils.toString(ol.max), "\u221E")
        })));

        this.relationsToTable = this.selectedObjectType == null ? null : new TableData([
            new TableColumn("objectType", "Darf enthalten sein in", TableCellType.text, { flex: 1 }),
            new TableColumn("max", "Anzahl", TableCellType.int, { autoWidth: 3 })
        ], this.selectedObjectType.mainType == EnaioMainType.folder ? [] : this.selectedObjectType.parent.objectTypes.filter(ot => (ot.mainType == EnaioMainType.folder || ot.mainType == EnaioMainType.register) && Utils.arrayFindAndConvert(ot.objectLimits, ol => ol.typeId == this.selectedObjectType.Id, ol => ol.max, 1) != 0).map(ot => new TableRow("", ot, {
            objectType: ot.name,
            max: Utils.arrayFindAndConvert(ot.objectLimits, ol => ol.typeId == this.selectedObjectType.Id, ol => Utils.toString(ol.max), "\u221E")
        })));

        this.plotDefinition = null;
        if (this.tabIndex == 10) {
            await this.initPlotDefinition();
        }
    }

    async fieldCellClicked(event: TableCellEvent): Promise<void> {
        let field = event.row.raw as EnaioGuiField;
        if (event.isButton("findUnique", "_tools")) {
            for (let row of this.fieldsSelectTable.rows) {
                row.values.key = field.internalName == (row.raw as EnaioGuiField).internalName;
            }
            this.dupType = 1;
            this.fieldsSelectTable = Utils.fromPlain(TableData, this.fieldsSelectTable);
            await this.getDuplicateDatasets();
            this.tabIndex = 6;
        }
        else if (event.isButton("jumpToEvent", "_tools")) {
            let sel = this.getSelectedObjectType();
            let event = this.events.find(e => (e.objectTypeId == -1 || e.objectTypeId == sel.Id) && e.parameters == field.osGuid);
            let xx = this.clientEventsScriptEditor._scripts.scripts;
            this.clientEventsScriptEditor.selectScript(this.clientEventsScriptEditor._scripts.scripts.find(script => script.id == event.calculatedSpeakingId));
            this.tabIndex = 2;
        }
        else if (event.isButton("showDropdownEntries", "_tools")) {
            let sel = this.getSelectedObjectType();
            await this.app.messageDialog.textArea("Listeneinträge", Utils.arrayItemsToString(field.listItems, "\n", li => li.text));
        }
    }

    async exportPrepare(): Promise<void> {
        this.exportOptions = await DhTools.backendCall("api/enaio/exportPrepare", {
            objectType: Utils.toJson(new EnaioObjectTypeId(EnaioObjectId.byInternalName(this.getSelectedObjectType().parent.internalName), this.getSelectedObjectType().getObjectId()))
        }).get(EnaioExportOptions);
    }

    async export(doIt: boolean): Promise<void> {
        if (doIt) {
            let dirName = await DhTools.saveDialog(null, true);
            if (!Utils.isNoe(dirName)) {
                DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/enaio/export", { dirName, options: Utils.toJson(this.exportOptions)}).getText(), _ => {
                });
            }
        }
        this.exportOptions = null;
    }

    async importPrepare(): Promise<void> {
        let exportDir = await DhTools.openDialog(null, true);
        if (!Utils.isNoe(exportDir)) {
            this.importOptions = await DhTools.backendCall("api/enaio/importPrepare", { exportDir }).get(EnaioImportOptions);
        }
    }

    async import(doIt: boolean): Promise<void> {
        if (doIt) {
            DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/enaio/import", { options: this.importOptions }).getText(), _ => {
            });
        }
        this.importOptions = null;
    }

    async loadUserRights(): Promise<void> {
        let call = Utils.fromPlain(EnaioCallGetUserPermissions, {
            objectTypeId: this.getSelectedObjectType().Id,
            detailed: true
        });
        let result = await DhTools.enaioCall<EnaioCheckPermissionResult[]>(call);

        this.userRightsTable = new TableData([
            new TableColumn("group", "Gruppe", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("delete", "Objekt löschen", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("readMetaData", "Indexdaten lesen", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("writeMetaData", "Indexdaten schreiben", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("update", "Objekt schreiben", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("openExec", "Objekt ausgeben", TableCellType.text, { autoWidth: 15 })
        ], result.map(p => new TableRow("", p, ({
            group: Utils.arrayFindAndConvert(this.userGroups, ug => ug.id == p.fromUserGroup, ug => ug.name, "<" + p.fromUserGroup + ">"),
            delete: this.getUserRightCell(p, EnaioAccessType.delete),
            readMetaData: this.getUserRightCell(p, EnaioAccessType.readMetaData),
            writeMetaData: this.getUserRightCell(p, EnaioAccessType.writeMetaData),
            update: this.getUserRightCell(p, EnaioAccessType.update),
            openExec: this.getUserRightCell(p, EnaioAccessType.openExec)
        }) as OrdinaryObject)));
    }

    async getDuplicateDatasets(): Promise<void> {
        let fields = this.fieldsSelectTable.rows.filter(row => row.values.key).map(row => row.raw as EnaioGuiField);
        if (fields.length == 0) {
            await this.app.messageDialog.show("Bitte mindestens ein Schlüsselfeld auswählen", "Fehler", [this.app.messageDialog.ok]);
            return;
        }
        this.duplicateDatasets = await DhTools.enaioCall(Utils.fromPlain(EnaioCallGetDuplicateDatasets, {
            archive: this.getSelectedObjectType().parent.getObjectId(),
            objectType: this.getSelectedObjectType().getObjectId(),
            fields: fields.map(f => EnaioObjectId.byInternalName(f.internalName)),
            conditions: this.fieldsSelectTable.rows.filter(row => !Utils.isNoe(row.values.condition)).map(row => new EnaioCondition(EnaioObjectId.byInternalName(row.raw.internalName as string), row.values.condition as string, "free")),
            maxResults: this.maxDups,
            minCount: this.dupType == 1 ? 1 : this.minCount
        }));
        this.duplicateDatasetsTable = new TableData([
            ...fields.map(f => new TableColumn(f.internalName, f.name, TableCellType.text, { flex: 1 })),
            new TableColumn("count", "Anzahl", TableCellType.int, { autoWidth: 7 }),
            new TableColumn("ids", "IDs", TableCellType.int, { autoWidth: 30})
        ], this.duplicateDatasets.map(p => new TableRow("", p, {
            ...Utils.arrayToMap(fields, f => f.internalName, f => p.key[f.internalName]),
            count: p.count,
            ids: p.ids == null ? "" : Utils.arrayItemsToString(p.ids, ", ")
        })), [new TableSortColumn("count", false)]);
        this.noDupIds = this.duplicateDatasets.length > 0 && !this.duplicateDatasets.some(p => !Utils.isNoe(p.ids));
        GuiUtils.angularTimer(() => {
            this.findDupsTabIndex = 1;
        });
    }

    async copyDupIds(preserveOldest: boolean): Promise<void> {
        let result: number[] = [];
        for (let p of this.duplicateDatasets) {
            if (p.ids.length > 1) {
                result = [...result, ...preserveOldest ? Utils.arraySort(p.ids).slice(1) : Utils.arraySort(p.ids).slice(null, -1)];
            }
        }
        await GuiUtils.copyToClipboard(Utils.arrayItemsToString(result, "\r\n"));
    }

    async openDupsInEnaio(preserveOldest?: boolean): Promise<void> {
        let result: number[] = [];
        for (let p of this.duplicateDatasets) {
            if (p.ids.length > 1) {
                result = [...result, ...preserveOldest == null ? p.ids : preserveOldest ? Utils.arraySort(p.ids).slice(1) : Utils.arraySort(p.ids).slice(null, -1)];
            }
        }
        if (result.length == 0) {
            this.app.showToast("error", "Keine Objekte", "Es wurde keine Objekte gefunden, die geöffnet werden können");
        }
        await DhTools.backendCall("api/enaio/openResultList", { ids: Utils.arrayItemsToString(result, ";")}).getText();
    }

    async generateDhFieldList(): Promise<void> {
        let result = await DhTools.backendCall("api/enaio/getDhConfigFieldList", {objectTypeId: this.getSelectedObjectType().Id}).getString();
        this.app.messageDialog.textArea("Vorlage", result, null, true);
    }

    async generateDhImportSource(): Promise<void> {
        let result = await DhTools.backendCall("api/enaio/getDhConfigImportSource", {objectTypeId: this.getSelectedObjectType().Id}).getString();
        this.app.messageDialog.textArea("Vorlage", result, null, true);
    }

    async generateDhFromEnaioWorker(): Promise<void> {
        let result = await DhTools.backendCall("api/enaio/getDhConfigFromEnaioWorker", {objectTypeId: this.getSelectedObjectType().Id}).getString();
        this.app.messageDialog.textArea("Vorlage", result, null, true);
    }

    async generateDhToEnaioWorker(): Promise<void> {
        let result = await DhTools.backendCall("api/enaio/getDhConfigToEnaioWorker", {objectTypeId: this.getSelectedObjectType().Id}).getString();
        this.app.messageDialog.textArea("Vorlage", result, null, true);
    }

    async exportObjectDef(): Promise<void> {
        let fileName = await DhTools.saveDialog("asobjdef.xml");
        if (!Utils.isNoe(fileName)) {
            await DhTools.backendCall("api/enaio/saveObjectDef", { fileName }).getString();
            await DhTools.backendCall("api/system/openDir", { fileName }).getString();
            this.app.showToast("success", "Erfolgreich", "Die Objektdefinition wurde exportiert");
        }
    }

    async saveClientEvent(items: FrontendScriptDefinition[]): Promise<void> {
        let evt = Utils.cloneDeep(items[0].raw as EnaioClientEvent);
        evt.code = items[0].code;
        await DhTools.enaioCall(Utils.fromPlain(EnaioCallUpdateClientEvent, { evt }));
    }

    private getUserRightCell(p: EnaioCheckPermissionResult, type: EnaioAccessType): string {
        let data = p.accessTypes.find(t => t.accessType == type);
        return data?.allow ? !Utils.isNoe(data.readableClause) ? data.readableClause : !Utils.isNoe(data.clause) ? data.clause : "Ja" : "Nein";
    }

    async getObjectCounts(objectTypeInternalName?: string): Promise<void> {
        this.objectCounts = new Map2<string, number>(await DhTools.enaioCall(Utils.fromPlain(EnaioCallGetObjectCounts, { objectTypeInternalNames: objectTypeInternalName != null ? [objectTypeInternalName] : null }))).toOrdinaryObject();
    }

    async openResultList(objectType: EnaioObjectType): Promise<void> {
        await DhTools.backendCall("api/enaio/search", { select: Utils.fromPlain(EnaioCallSelect, {
            archive: EnaioObjectId.byInternalName(objectType.parent.internalName),
            objectType: EnaioObjectId.byId(objectType.Id)
        })}).getText();
    }

    async fixRenditionCache(objectType: EnaioObjectType): Promise<void> {
        if (!await this.app.messageDialog.yesNo("Dies wird alle (potenziell viele) Dokumente in diesem Objekttyp prüfen und ggf. neu in die CPM-Queue stellen. Fortfahren?")) {
            return;
        }
        let count = await DhTools.backendCall("api/enaio/fixRenditionCache", { objectTypeId: new EnaioObjectTypeId(EnaioObjectId.byInternalName(objectType.parent.internalName), EnaioObjectId.byId(objectType.Id)) }).getNumber();
        this.app.showToast("success", "Rendition Cache gefixed", "Insgesamt " + count + " Dokumente wurden erneut in die CPM-Queue eingereiht");
    }

    async findValues(): Promise<void> {
        let connectionConfig = await DhTools.backendCall("api/dh/getEnaioDbConnection").get(DbConnectionConfig);
        let allOt = this.def.getAllObjectTypes();
        let searchArea = this.findValueForm.getValue("searchArea") as string;

        DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/tools/databaseFindValue", {
            connectionConfig,
            query: this.findValueForm.getValue("query"),
            like: this.findValueForm.getValue("like"),
            tableNameRegex: "(" + Utils.arrayItemsToString((searchArea == "Dieser Objekttyp" ? [this.getSelectedObjectType()] : searchArea == "Dieser Schrank" ? this.getSelectedObjectType().parent.objectTypes : allOt).map(ot => ot.tableName), "|") + ")(list[0-9]+)?$"
        }).getText(), r => {
            let result = Utils.fromPlainArray(DatabaseValueFound, Utils.fromJson(r.value) as any[]);
            this.findValueTable = new TableData([
                new TableColumn("archive", "Archiv", TableCellType.text, { autoWidth: 20 }),
                new TableColumn("objectType", "Objekttyp", TableCellType.text, { autoWidth: 20 }),
                new TableColumn("field", "Feld", TableCellType.text, { autoWidth: 20 }),
                new TableColumn("count", "Anzahl", TableCellType.int, { autoWidth: 7 })
            ], result.map(item => {
                let tableName = Utils.getSubstringTo(item.tableName.tableName, "list");
                let tableFieldName = item.tableName.tableName.includes("list") ? "list" + Utils.getSubstringFrom(item.tableName.tableName, "list") : null;
                let ot = allOt.find(ot => ot.tableName == tableName);
                let tableField = tableFieldName != null && ot != null ? ot.getAllFields().find(field => Utils.stringEqualsCi(field.dbFieldName, tableFieldName)) : null; 
                return new TableRow("", item, {
                    archive: ot?.parent?.name ?? "<???>",
                    objectType: ot?.name ?? "<???>",
                    field: (tableField != null ? tableField.name + "." + tableField.tableColumns.find(col => Utils.stringEqualsCi(col.dbName, item.columnName))?.name : ot?.getAllFields().find(f => Utils.stringEqualsCi(f.dbFieldName, item.columnName))?.name) ?? "<???>",
                    count: item.count
                });
        }))});
    }

    async loadHistory(): Promise<void> {
        //let allOt = this.def.getAllObjectTypes();
        //let searchArea = this.historyForm.getValue("searchArea") as string;

        let compareToFileName = this.historyForm.getValue("compareToFileName");
        if (Utils.isNoe(compareToFileName)) {
            DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/enaio/getObjectDefHistory").getText(), r => {
                this.fillHistoryTable(Utils.fromPlainArray(EnaioObjectDefChange, Utils.fromJson(r.value) as any[]));
            });
        }
        else {
            this.fillHistoryTable(await DhTools.backendCall("api/enaio/compareObjectDefs", { compareToFileName }).list(EnaioObjectDefChange));
        }
    }

    async loadStatistics(): Promise<void> {
        let allOt = this.def.getAllObjectTypes();
        let searchArea = this.statisticsForm.getValue("searchArea") as string;
        let ots = searchArea == "Dieser Objekttyp" ? [this.getSelectedObjectType()] : searchArea == "Dieser Schrank" ? this.getSelectedObjectType().parent.objectTypes : allOt;
        

        DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/enaio/getObjectTypeStatistics", { call: Utils.fromPlain(EnaioCallGetObjectTypeStatistics, {
            objectTypes: ots.map(ot => ot.getObjectTypeId()),
            byMimeType: this.statisticsForm.getValue("byMimeType"),
            followForeignIds: this.statisticsForm.getValue("followForeignIds"),
            countDuplicateForeignIds: this.statisticsForm.getValue("countDuplicateForeignIds"),
            countMultipleDocumentsOfIdAsOne: this.statisticsForm.getValue("countMultipleDocumentsOfIdAsOne"),
            conditions: this.statisticsForm.getValue("conditions")
        })}).getText(), r => {
            this.fillStatisticsTable(Utils.fromPlainArray(EnaioObjectTypeStatistics, Utils.fromJson(r.value) as any[]));
        });    
    }


    fillHistoryTable(data: EnaioObjectDefChange[]): void {
        this.historyTable = new TableData([
            new TableColumn("date", "Datum", TableCellType.dateTime, { autoWidth: 1 }),
            new TableColumn("archive", "Archiv", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("objectType", "Objekttyp", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("field", "Feld", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("change", "Änderung", TableCellType.text, { flex: 1 })
        ], data.map(item => new TableRow("", item, {
            date: item.date,
            archive: item.archive?.name,
            objectType: item.objectType?.name,
            field: item.field?.name,
            change: item.change
        }), [new TableSortColumn("date", false)]));
    }

    fillStatisticsTable(data: EnaioObjectTypeStatistics[]): void {
        let useForeign = this.statisticsForm.getValue("followForeignIds") as boolean;
        let mimeTypes = Utils.arraySort(Utils.arrayGetUnique(Utils.arrayExplode(data, item => Utils.getOwnPropertyNames(item.documentCountByMimeType))));
        let foreignTypes = Utils.arraySort(Utils.arrayGetUnique(Utils.arrayExplode(data, item => Utils.getOwnPropertyNames(item.documentCountByForeign))));
        this.statisticsTable = new TableData([
            new TableColumn("archive", "Archiv", TableCellType.text, { autoWidth: 20, frozen: "left" }),
            new TableColumn("objectType", "Objekttyp", TableCellType.text, { autoWidth: 20, frozen: "left" }),
            new TableColumn("objectCount", "# Objekte", TableCellType.int, { autoWidth: 8 }),
            new TableColumn("objectCountForeign", "Verweis", TableCellType.int, { autoWidth: 8 }),
            new TableColumn("documentCount", "Dieser Typ", TableCellType.int, { autoWidth: 8, groupCaption: "# Dokumente" }),
            useForeign ? new TableColumn("documentCountForeign", "Verweis", TableCellType.int, { autoWidth: 8, groupCaption: "# Dokumente" }) : null,            
            ...foreignTypes.map(foreignType => new TableColumn("documentCount_foreignType_" + foreignType, foreignType, TableCellType.int, { autoWidth: 8, groupCaption: "# Dokumente" })),
            ...mimeTypes.map(mimeType => new TableColumn("documentCount_mimeType_" + mimeType, mimeType, TableCellType.int, { autoWidth: 8, groupCaption: "# Dokumente" })),
            new TableColumn("pageCount", "Dieser Typ", TableCellType.int, { autoWidth: 8, groupCaption: "# Seiten" }),
            useForeign ? new TableColumn("pageCountForeign", "Verweis", TableCellType.int, { autoWidth: 8, groupCaption: "# Seiten" }) : null,            
            ...foreignTypes.map(foreignType => new TableColumn("pageCount_foreignType_" + foreignType, foreignType, TableCellType.int, { autoWidth: 8, groupCaption: "# Seiten" })),
            ...mimeTypes.map(mimeType => new TableColumn("pageCount_mimeType_" + mimeType, mimeType, TableCellType.int, { autoWidth: 8, groupCaption: "# Seiten" })),
            new TableColumn("fileSize", "Dieser Typ", TableCellType.byteSize, { autoWidth: 8, groupCaption: "Dateigröße" }),
            useForeign ? new TableColumn("fileSizeForeign", "Verweis", TableCellType.byteSize, { autoWidth: 8, groupCaption: "Dateigröße" }) : null,            
            ...foreignTypes.map(foreignType => new TableColumn("fileSize_foreignType_" + foreignType, foreignType, TableCellType.byteSize, { autoWidth: 8, groupCaption: "Dateigröße" })),
            ...mimeTypes.map(mimeType => new TableColumn("fileSize_mimeType_" + mimeType, mimeType, TableCellType.byteSize, { autoWidth: 8, groupCaption: "Dateigröße" })),
            useForeign ? new TableColumn("documentCountTotal", "# Dokumente", TableCellType.int, { autoWidth: 8, groupCaption: "TOTAL" }) : null,
            useForeign ? new TableColumn("pageCountTotal", "# Seiten", TableCellType.int, { autoWidth: 8, groupCaption: "TOTAL" }) : null,
            useForeign ? new TableColumn("fileSizeTotal", "# Dateigröße", TableCellType.byteSize, { autoWidth: 8, groupCaption: "TOTAL" }) : null,
                        
        ], data.map(item => new TableRow("", item, {
            archive: item.id.archive?.name,
            objectType: item.id.objectType?.name,
            objectCount: item.objectCount,
            objectCountForeign: item.objectCountForeign,
            documentCount: item.documentCount,
            documentCountForeign: item.documentCountForeign,
            ...Utils.arrayConvertToOrdinaryObject(mimeTypes, mimeType => "documentCount_mimeType_" + mimeType, mimeType => Utils.getSafe(item.documentCountByMimeType, mimeType, 0)), 
            ...Utils.arrayConvertToOrdinaryObject(foreignTypes, foreignType => "documentCount_foreignType_" + foreignType, foreignType => Utils.getSafe(item.documentCountByForeign, foreignType, 0)), 
            pageCount: item.pageCount,
            pageCountForeign: item.pageCountForeign,
            ...Utils.arrayConvertToOrdinaryObject(mimeTypes, mimeType => "pageCount_mimeType_" + mimeType, mimeType => Utils.getSafe(item.pageCountByMimeType, mimeType, 0)), 
            ...Utils.arrayConvertToOrdinaryObject(foreignTypes, foreignType => "pageCount_foreignType_" + foreignType, foreignType => Utils.getSafe(item.pageCountByForeign, foreignType, 0)), 
            fileSize: item.fileSize,
            fileSizeForeign: item.fileSizeForeign,
            ...Utils.arrayConvertToOrdinaryObject(mimeTypes, mimeType => "fileSize_mimeType_" + mimeType, mimeType => Utils.getSafe(item.fileSizeByMimeType, mimeType, 0)),
            ...Utils.arrayConvertToOrdinaryObject(foreignTypes, foreignType => "fileSize_foreignType_" + foreignType, foreignType => Utils.getSafe(item.fileSizeByForeign, foreignType, 0)),
            documentCountTotal: item.documentCount + item.documentCountForeign,
            pageCountTotal: item.pageCount + item.pageCountForeign,
            fileSizeTotal: item.fileSize + item.fileSizeForeign
                  
        }), [new TableSortColumn("archive"), new TableSortColumn("objectType")]));
    }


    getSelectedObjectTypeId(): EnaioObjectTypeId {
        let ot = this.getSelectedObjectType();
        return new EnaioObjectTypeId(EnaioObjectId.byName(ot.parent.name), EnaioObjectId.byName(ot.name));
    }

    async activeTabChanged(): Promise<void> {
        if (this.tabIndex == 4) {
            await this.loadUserRights();
        }
        else if (this.tabIndex == 11) {
            await this.initPlotDefinition();
        }
    }

    async initPlotDefinition(): Promise<void> {
        if (this.plotDefinition != null) {
            return;
        }
        this.plotDefinition = new PlotDefinition();
        this.plotFields = this.getSelectedObjectType().getAllFields().map(field => new GenericFieldDefinition(field.name, GenericDataType.string));
        this.plotTemplates = await DhTools.backendCall("api/enaio/plotGetStoredTemplates", { objectTypeId: this.getSelectedObjectTypeId() }).list(PlotDefinition);
        GuiUtils.angularTimer(() => this.plotDefComponent.generateForm());
    }

    async generatePlot(): Promise<void> {
        this.plotData = await DhTools.backendCall("api/enaio/plot", { plotDefinition: this.plotDefComponent.getDefinition(), objectTypeId: this.getSelectedObjectTypeId() }).get(PlotResult);
        this.plotData.rows = this.plotData.rows.filter(pd => pd[0] != "0001-01-01T00:00:00" && pd[1] != "0001-01-01T00:00:00" && Utils.arrayGetSafe(pd, 2) != "0001-01-01T00:00:00");
        this.plotData.ensureDataTypes();

        this.plot.generate(this.plotDefinition, this.plotData);
    }

    async storePlotTemplate(def: PlotDefinition): Promise<void> {
        await DhTools.backendCall("api/enaio/plotStoreTemplate", { plotDefinition: def, objectTypeId: this.getSelectedObjectTypeId() }).getText();
        this.plotTemplates = await DhTools.backendCall("api/enaio/plotGetStoredTemplates", { objectTypeId: this.getSelectedObjectTypeId() }).list(PlotDefinition);
        GuiUtils.angularTimer(() => this.plotDefComponent.generateForm());
    }

}
